package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class KeychainItemQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByKeychain(keychain_id: String, mapper: (
    id: String,
    keychain_id: String,
    payload: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByKeychainQuery(keychain_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByKeychain(keychain_id: String): Query<Keychain_item> =
      selectByKeychain(keychain_id) { id, keychain_id_, payload, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Keychain_item(
      id,
      keychain_id_,
      payload,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    keychain_id: String,
    payload: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Keychain_item> = selectByIdAnyState(id) { id_,
      keychain_id, payload, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Keychain_item(
      id_,
      keychain_id,
      payload,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    keychain_id: String,
    payload: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(795_363_847, arrayOf("keychain_item"), driver, "KeychainItem.sq",
      "selectDirty",
      "SELECT keychain_item.id, keychain_item.keychain_id, keychain_item.payload, keychain_item.order_index, keychain_item.created_at, keychain_item.updated_at, keychain_item.is_deleted, keychain_item.deleted_at, keychain_item.synced_at FROM keychain_item WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectDirty(): Query<Keychain_item> = selectDirty { id, keychain_id, payload,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Keychain_item(
      id,
      keychain_id,
      payload,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectAll(mapper: (
    id: String,
    keychain_id: String,
    payload: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_813_698_282, arrayOf("keychain_item"), driver, "KeychainItem.sq",
      "selectAll",
      "SELECT keychain_item.id, keychain_item.keychain_id, keychain_item.payload, keychain_item.order_index, keychain_item.created_at, keychain_item.updated_at, keychain_item.is_deleted, keychain_item.deleted_at, keychain_item.synced_at FROM keychain_item WHERE is_deleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectAll(): Query<Keychain_item> = selectAll { id, keychain_id, payload, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Keychain_item(
      id,
      keychain_id,
      payload,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    keychain_id: String,
    payload: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(783_259_208, """
        |INSERT INTO keychain_item(id, keychain_id, payload, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindString(0, id)
          bindString(1, keychain_id)
          bindString(2, payload)
          bindLong(3, order_index)
          bindLong(4, created_at)
          bindLong(5, updated_at)
        }
    notifyQueries(783_259_208) { emit ->
      emit("keychain_item")
    }
  }

  public fun updatePayload(
    payload: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-541_631_978,
        """UPDATE keychain_item SET payload = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, payload)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-541_631_978) { emit ->
      emit("keychain_item")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(670_864_004,
        """UPDATE keychain_item SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(670_864_004) { emit ->
      emit("keychain_item")
    }
  }

  public fun softDeleteByKeychain(
    deleted_at: Long?,
    updated_at: Long,
    keychain_id: String,
  ) {
    driver.execute(-1_039_294_755,
        """UPDATE keychain_item SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE keychain_id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, keychain_id)
        }
    notifyQueries(-1_039_294_755) { emit ->
      emit("keychain_item")
    }
  }

  public fun updateFromRemote(
    keychain_id: String,
    payload: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_550_151_432,
        """UPDATE keychain_item SET keychain_id = ?, payload = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        5) {
          bindString(0, keychain_id)
          bindString(1, payload)
          bindLong(2, order_index)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(1_550_151_432) { emit ->
      emit("keychain_item")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_946_579_167,
        """UPDATE keychain_item SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_946_579_167) { emit ->
      emit("keychain_item")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_873_757_622,
        """UPDATE keychain_item SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_873_757_622) { emit ->
      emit("keychain_item")
    }
  }

  private inner class SelectByKeychainQuery<out T : Any>(
    public val keychain_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("keychain_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("keychain_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-122_390_492,
        """SELECT keychain_item.id, keychain_item.keychain_id, keychain_item.payload, keychain_item.order_index, keychain_item.created_at, keychain_item.updated_at, keychain_item.is_deleted, keychain_item.deleted_at, keychain_item.synced_at FROM keychain_item WHERE keychain_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, keychain_id)
    }

    override fun toString(): String = "KeychainItem.sq:selectByKeychain"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("keychain_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("keychain_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-914_071_518,
        """SELECT keychain_item.id, keychain_item.keychain_id, keychain_item.payload, keychain_item.order_index, keychain_item.created_at, keychain_item.updated_at, keychain_item.is_deleted, keychain_item.deleted_at, keychain_item.synced_at FROM keychain_item WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "KeychainItem.sq:selectByIdAnyState"
  }
}
